import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastService } from './toast.service';
import { LanguageService } from './language.service';

/**
 * Surfaces *infrastructure* failures (no connection, server errors) as a toast so
 * fetches don't fail silently. 4xx responses are intentionally NOT toasted —
 * components handle those contextually (not-found states, form validation,
 * inline rate-limit messages). The error is always re-thrown so those handlers
 * still run.
 */
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private toast: ToastService, private lang: LanguageService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 0) {
          this.toast.error(this.lang.isArabic
            ? 'تعذّر الوصول إلى الخادم. يرجى التحقق من اتصالك بالإنترنت.'
            : 'Cannot reach the server. Please check your internet connection.');
        } else if (err.status >= 500) {
          this.toast.error(this.lang.isArabic
            ? 'حدث خطأ في الخادم. يرجى المحاولة لاحقًا.'
            : 'A server error occurred. Please try again later.');
        }
        return throwError(() => err);
      })
    );
  }
}
